import type { TagBulkChargeFamilyPreview } from '~entities/payment/api/bulk-charge-by-tags';

import type { Student } from '~pages/payments/bulk-charge-students';

export const STUDENT_SELECTION_MODE = {
  MANUAL: 'manual',
  CLASS: 'class',
  GROUP: 'group',
  TAG: 'tag',
} as const;

export type StudentSelectionMode =
  (typeof STUDENT_SELECTION_MODE)[keyof typeof STUDENT_SELECTION_MODE];

export interface StudentSelectionModeOption {
  value: StudentSelectionMode;
  label: string;
  shortLabel: string;
}

export interface StudentSelectionStepProps {
  onStudentsSelected: (students: Array<Student>) => void;
  onFamiliesSelected?: (families: Array<TagBulkChargeFamilyPreview>) => void;
}
